import Topnav from './components/Nav/TopBar';
import Sidebar from './components/Nav/SideBar';

import { useStateContext } from './components/Context/ContextProvider';
import AuthToken from './components/Context/AuthToken';
import ProtectedRoute from './components/Context/ProtectedRoute';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import Home from './pages/Home';
import Login from './pages/Login';
import Customers from './pages/Customer/Customers'
import ViewCustomer from './pages/Customer/ViewCustomer'
import AddCustomer from './pages/Customer/AddCustomer'
import ListUsers from './pages/Admins/ListAdmins'
import AddUsers from './pages/Admins/AddAdmin'
import UpdateUser from './pages/Admins/UpdateAdmin'
import Profile from './pages/Admins/Profile'
import Successful from './pages/Requests/Successful'
import Failed from './pages/Requests/Failed'
import Reversed from './pages/Requests/Reversed'
import C2bConfirmation from './pages/Payments/C2bConfirmation'
import StkResultCdr from './pages/Payments/StkResultCdr'
import StkPushArchieve from './pages/Payments/StkPushArchieve'
import AllCustomers from './pages/Reports/AllCustomers'
import SuccessfulRequests from './pages/Reports/SuccessfulRequests'
import C2bConfirmations from './pages/Reports/C2bConfirmations'

const App = () => {
  const { activeMenu } = useStateContext();

  const { accessToken, setAccessToken } = AuthToken();
  if (!accessToken) {
    return <Login setAccessToken={setAccessToken} />;
  }

  return (
    <main>
      <div className='flex relative'>
        {activeMenu ? (
          <div className='w-60 fixed'>
            <Sidebar />
          </div>
        ) : (
          <div>
            <Sidebar />
          </div>
        )}
        <div className={activeMenu ? 'min-h-screen md:ml-60 w-full' : 'w-full min-h-screen flex-2'}>
          <div>
            <Topnav />
          </div>
          <div>
            <Toaster position='top-center' richColors />
            <Routes>
              {/* dashboard  */}
              <Route path='/' element={<Home />} />
              <Route path='/login' element={<Login setAccessToken={setAccessToken} />} />
              <Route path='/customers' element={<Customers />} />
              <Route path='/customer/:id' element={<ViewCustomer />} />
              <Route path='/add-customer' element={<AddCustomer />} />
              <Route path='/admins' element={<ProtectedRoute><ListUsers /></ProtectedRoute>} />
              <Route path='/addadmin' element={<ProtectedRoute><AddUsers /></ProtectedRoute>} />
              <Route path='/updateadmin/:id' element={<ProtectedRoute><UpdateUser /></ProtectedRoute>} />
              <Route path='/my-profile' element={<Profile />} />
              <Route path='/successful' element={<Successful />} />
              <Route path='/failed' element={<Failed />} />
              <Route path='/reversed' element={<Reversed />} />
              <Route path='/c2b-confirmation' element={<C2bConfirmation />} />
              <Route path='/stk-result-cdr' element={<StkResultCdr />} />
              <Route path='/stk-push-archieve' element={<StkPushArchieve />} />
              <Route path='/all-customers' element={<AllCustomers />} />
              <Route path='/successful-requests' element={<SuccessfulRequests />} />
              <Route path='/c2bconfirmations' element={<C2bConfirmations />} />
            </Routes>
          </div>
        </div>
      </div>
    </main>
  );
};

export default App;
